module.exports = __webpack_public_path__ + "static/tar-3b972e8a784cf19d2dc7d032fb7184b3.jpg";